/**
 * FooterOnly (ported from facilio-website/components/FooterOnly.vue)
 * - Replace Bootstrap accordion with a lightweight vanilla accordion
 */

(function () {
  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function initFooterOnlyAccordion() {
    var roots = $all("[data-footer-only-accordion]");
    if (!roots.length) return;

    roots.forEach(function (root) {
      var items = $all(".footer-only__acc-item", root);
      items.forEach(function (item) {
        var btn = item.querySelector(".footer-only__acc-btn");
        var panel = item.querySelector(".footer-only__acc-panel");
        if (!btn || !panel) return;

        // Set baseline styles for animation
        panel.style.maxHeight = "0px";
        panel.style.transition = "max-height 0.25s cubic-bezier(0.4, 0, 0.2, 1)";
        panel.style.willChange = "max-height";

        function setOpen(open) {
          btn.setAttribute("aria-expanded", open ? "true" : "false");
          if (open) {
            panel.hidden = false;
            panel.style.maxHeight = panel.scrollHeight + "px";
          } else {
            panel.style.maxHeight = "0px";
            // wait for animation, then hide
            window.setTimeout(function () {
              if (btn.getAttribute("aria-expanded") === "false") {
                panel.hidden = true;
              }
            }, 260);
          }
        }

        // Start closed
        setOpen(false);

        btn.addEventListener("click", function () {
          var isOpen = btn.getAttribute("aria-expanded") === "true";
          setOpen(!isOpen);
        });

        btn.addEventListener("keydown", function (e) {
          if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
            e.preventDefault();
            btn.click();
          }
        });
      });

      // Fix open panel heights on resize
      var t = null;
      window.addEventListener("resize", function () {
        if (t) window.clearTimeout(t);
        t = window.setTimeout(function () {
          items.forEach(function (item) {
            var btn = item.querySelector(".footer-only__acc-btn");
            var panel = item.querySelector(".footer-only__acc-panel");
            if (!btn || !panel) return;
            var isOpen = btn.getAttribute("aria-expanded") === "true";
            if (isOpen) {
              panel.style.maxHeight = panel.scrollHeight + "px";
            }
          });
        }, 100);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFooterOnlyAccordion);
  } else {
    initFooterOnlyAccordion();
  }
})();


